/* Market links. Loaded only on prefixed markets (/en-us, /de-de, any added later).

   A prefix sets the cart currency, so one link without it moves the shopper's
   cart back to AUD. Liquid sections use cp-market-url; this catches what Liquid
   cannot reach: rich text, policy and page bodies, product descriptions, and
   markup added after load. */
(function () {
  'use strict';

  var script = document.currentScript;
  var root = script && script.dataset.root;
  if (!root || root === '/') return;

  /* A market prefix is left alone. A language-only prefix (/de) is not one: it
     is the primary market in that language, so it moves the cart as well. Shopify's
     own cookie banner links that way. */
  var MARKET = /^\/[a-z]{2}-[a-z]{2}(\/|$)/i;
  var LANGUAGE = /^\/[a-z]{2}(\/|$)/i;
  var SKIP = /^\/(cdn|checkout|checkouts|account|customer_authentication|services|tools|admin|wpm|web-pixels|password|challenge|localization|cart\/(add|change|update|clear))(\/|\.|$)/i;

  function localise(link) {
    if (link.protocol !== 'https:' && link.protocol !== 'http:') return;
    if (link.host !== location.host) return;
    if (MARKET.test(link.pathname)) return;
    var path = link.pathname.replace(LANGUAGE, '/');
    if (SKIP.test(path)) return;
    link.setAttribute('href', root + path + link.search + link.hash);
  }

  function sweep(scope) {
    if (scope.matches && scope.matches('a[href]')) localise(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('a[href]').forEach(localise);
  }

  /* Last chance, for a link changed since the sweep. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (link) localise(link);
  }, true);

  sweep(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) sweep(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
